export default "__VITE_ASSET__u7lZCXsx__"